import { useEffect } from 'react'
import { useSearchParams, Link } from 'react-router-dom'
import { BASE_URL } from '../lib/api'

/**
 * Public route: same path as invite emails (`/invite/accept?token=`).
 * Forwards to the Worker, which completes onboarding (e.g. Slack OAuth).
 */
export function InviteAcceptRedirectPage() {
  const [params] = useSearchParams()
  const token = params.get('token')

  useEffect(() => {
    if (!token) return
    window.location.replace(`${BASE_URL}/api/invites/accept?token=${encodeURIComponent(token)}`)
  }, [token])

  if (!token) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center p-6" style={{ background: '#F5F2EA' }}>
        <p className="text-sm text-ink-muted">This invite link is missing a token.</p>
        <Link to="/login" className="text-sm text-brand-teal mt-4 font-medium hover:underline">
          Sign in
        </Link>
      </div>
    )
  }

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-3 p-6" style={{ background: '#F5F2EA' }}>
      <div className="text-3xl animate-pulse" aria-hidden>
        🕊
      </div>
      <p className="text-sm text-ink-muted">Opening your invite…</p>
    </div>
  )
}
